export default __webpack_public_path__ + "static/media/area-64.39eb9908.jpg";